<template>
  <section>
    <p class="mb-8">
      2024년 우리동네 크라우드펀딩 사업은 중소벤처기업부, 소상공인시장진흥공단이 주도하고 (주)펀다가
      협력기관으로 참여하는 상생형 크라우드펀딩사업입니다.
    </p>

    <div class="mb-8">
      <p class="font-weight-black">(주)펀다 대표 박성준</p>
      <p>서울 서초구 사평대로53길 30 메이크잇 203호 ,204호</p>
      <p>사업자등록번호 724-87-00107</p>
      <p>온라인투자연계금융업 2022-금융위원회-18</p>
    </div>

    <div class="mb-8">
      <p>대출금리 연 최고 17.9% 이내, 연체이자율 : 약정금리 +3% (법정최고금리 20%이내),</p>
      <p>플랫폼 이용료 외 취급수수료 등 기타 부대비용은 없음, 조기상환조건 없음</p>
    </div>

    <div class="mb-8 font-weight-black">
      <p>중개수수료를 요구하거나 받는 행위는 불법입니다.</p>
      <p>대출 시 귀하의 신용평점이 하락할 수 있습니다.</p>
      <p>과도한 빚은 당신에게 큰 불행을 안겨줄 수 있습니다.</p>
    </div>

    <div>
      <p class="font-weight-black">
        대표번호 <a href="tel:02-6925-1788" class="tell-link">02-6925-1788</a>
      </p>
      <p>Copyright © FUNDA 2020. All Right Reserved.</p>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
* {
  font-size: 14px;
}

p,
.tell-link {
  margin-bottom: 0;
  color: #727d8c;
  text-decoration: none;
}
section {
  background-color: #f5f5f5;
  padding: 32px 24px;
}
</style>
